"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rememberCameraViewOffset = void 0;
var rememberCameraViewOffset = exports.rememberCameraViewOffset = function rememberCameraViewOffset(camera) {
  var view = camera.view;
  if (!view) {
    return function () {
      return null;
    };
  }
  var fullWidth = view.fullWidth,
    fullHeight = view.fullHeight,
    offsetX = view.offsetX,
    offsetY = view.offsetY,
    width = view.width,
    height = view.height;
  return function () {
    return camera.setViewOffset(fullWidth, fullHeight, offsetX, offsetY, width, height);
  };
};